// 📧 Inscription par e-mail en attente du code (compte pas encore vérifié) : gardée dans le
// navigateur pour pouvoir quitter la page du code puis y revenir (« Terminer mon inscription »,
// « Renvoyer le code ») ou l'annuler. Jamais un jeton de connexion : seulement l'identifiant du
// compte, son adresse et le jeton d'inscription remis par l'API (valable 2 h).
const KEY = "pendingRegistration";
const MAX_AGE_MS = 2 * 60 * 60 * 1000;

export const savePendingRegistration = ({ id, registration_token, email }) => {
  try {
    if (id && registration_token) localStorage.setItem(KEY, JSON.stringify({ id, registration_token, email: email || "", saved_at: Date.now() }));
  } catch (e) {}
};

// Inscription en attente, ou null (absente, illisible ou plus vieille que le jeton d'inscription)
export const pendingRegistration = () => {
  try {
    const pending = JSON.parse(localStorage.getItem(KEY) || "null");
    if (pending?.id && pending?.registration_token && Date.now() - pending.saved_at < MAX_AGE_MS) return pending;
    localStorage.removeItem(KEY);
  } catch (e) {}
  return null;
};

export const clearPendingRegistration = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {}
};
